import { CloseOutlined } from '@ant-design/icons'
import { Checkbox, Form, Input, Modal } from 'antd'
import React, { memo, useEffect, useRef } from 'react'
import useThrottle from '../../../../../../hook/useThrottle'
import './../../../styles.scss'

interface ModalProps {
    isOpen: boolean

    onSubmitFormModal: (value: any) => void
    closeModal: (e: boolean) => void

}

const ModalSaveFilterAndCreatGroup: React.FC<ModalProps> = ({
    isOpen,
    onSubmitFormModal, closeModal,
}) => {

    const formRef: any = useRef(null)
    const [form] = Form.useForm();

    const onFinish = useThrottle(async (values: any) => {
        onSubmitFormModal(values)
    }, 1000)

    const handleSave = () => {
        formRef.submit()
    }

    useEffect(() => {
        if (!isOpen && form) {
            form.resetFields()
        }
    }, [isOpen, form])

    return (
        <Form
            ref={formRef}
            form={form}
            onFinish={onFinish}
            initialValues={{ remember: true }}
            className='custom-page-css flex flex-col gap-2'
        >
            <Modal
                title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
                    <span className=" custom-page-css text-344054 text-lg  font-medium">Tạo mới nhóm khách hàng</span>
                    <CloseOutlined className="text-base text-8B8B8B"
                        onClick={() => closeModal(false)}
                    />
                </div>}
                open={isOpen}
                onCancel={() => closeModal(false)}
                centered
                className=" custom-page-css overflow-hidden modal-content-addCustomer ant-modal-size rounded"
                closeIcon={false}
                footer={
                    <div className='d-flex justify-end gap-2 p-2 border-t-F0F0F0 bg-FCFCFD'>
                        <button
                            className=' border-F2F4F7 text-sm rounded-2 h-8 px-3 font-regular '
                            onClick={() => closeModal(false)}
                        >
                            Huỷ
                        </button>
                        <button
                            className='border-none bg-096DD9 text-sm rounded-2 h-8 px-3 font-regular text-white'
                            onClick={() => formRef?.current.submit()}
                        >
                            Lưu
                        </button>
                    </div>
                }
            >
                <div className="input-add-name px-6 py-4">

                    <Form.Item
                        label={
                            <span className='font-regular text-sm'><span className="pr-1" style={{ color: "red" }}>
                                *
                            </span >
                                Tên nhóm:
                            </span>
                        }
                        name="title"
                        layout="vertical"
                        rules={[{ required: true, message: 'Vui lòng nhập tên nhóm!' }]}
                        className="m-none-form-item text-explan"
                    >
                        <Input className="plac-color" placeholder="Nhập tên nhóm" />
                    </Form.Item>
                    <Form.Item
                        // className='pt-5'
                        name="isAddCondition"
                        valuePropName="checked"
                    >
                        <Checkbox>Lưu tên bộ lọc danh sách khách hàng</Checkbox>
                    </Form.Item>
                </div>

            </Modal>
        </Form>
    )
}
export default memo(ModalSaveFilterAndCreatGroup)
